__webpack_require__.p = "/jwpwai/AdrianLewandowski21257/lab4ReactProd/build/";